module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "flex items-start justify-between"
  }, [_c('div', {
    staticClass: "col-8 connten-left"
  }, [_c('h3', [_vm._v("ติดต่อเรา")]), _c('ul', {
    staticClass: "list-reset"
  }, [_c('li', {
    staticClass: "flex items-start"
  }, [_c('label', {
    staticClass: "item-label"
  }, [_vm._v("อีเมลล์:")]), _c('div', {
    staticClass: "item-content"
  }, [_vm._v("thaidaily2020@gmail.com")])]), _c('li', {
    staticClass: "flex items-start"
  }, [_c('label', {
    staticClass: "item-label"
  }, [_vm._v("Line:")]), _c('div', {
    staticClass: "item-content"
  }, [_vm._v("thaidaily777")])]), _c('li', {
    staticClass: "flex items-start"
  }, [_c('label', {
    staticClass: "item-label"
  }, [_vm._v("ที่อยู่ :")]), _c('div', {
    staticClass: "item-content"
  }, [_vm._v("388/64 Nuan Chan Rd, Nuanchan, Bueng Kum, Bangkok 10230.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3cce42e8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 919
// module chunks = 1